import PolygonLogo from '../../assets/img/polygon.svg'
import EthereumLogo from '../../assets/img/ethereum.svg'
import BinanceLogo from '../../assets/img/binance.svg'
import OptimismLogo from '../../assets/img/optimism.svg'
import AvalancheLogo from '../../assets/img/avalanche.svg'
import ArbitrumLogo from '../../assets/img/arbitrum.png'
import { Network, SupportedNetwork } from '@spritz-finance/sdk'
import styled from 'styled-components'

const Logo = styled.img<{ $size?: number }>`
    height: ${({ $size }) => $size ?? 20}px;
`

export const NETWORK_TO_LOGO: Record<SupportedNetwork, string> = {
    [Network.Polygon]: PolygonLogo,
    [Network.Ethereum]: EthereumLogo,
    [Network.Binance]: BinanceLogo,
    [Network.Optimism]: OptimismLogo,
    [Network.Arbitrum]: ArbitrumLogo,
    [Network.Avalanche]: AvalancheLogo,
}

export const NetworkLogo = ({
    network,
    size = 20,
}: {
    network: SupportedNetwork
    size?: number
}) => {
    const logo = NETWORK_TO_LOGO[network]
    return <Logo src={logo} $size={size} />
}
